<template>
  <div class="t1">
    <nav_list></nav_list>
    <div class="wiwiw">

      <div class="lefefe">
        <div class="gb-tabs" v-loading.fullscreen.lock="fullscreenLoading">
          <div class="gb-tabs-header">
            <div class="gb-tab" v-bind:class="{ agtabat: i == current }" v-for="(itm, i) in tabList" :key="i"
              @click="onChange(i)">
              {{ itm.name }}
            </div>
          </div>
          <div class="gb-tabs-body">

            <div class="root2 zt">


              <div class="">


                <div class="sreach">

                  <div class="row" v-if="source == 'highwaybus'">
                    <div class="lab">
                      <i class="el-icon-location"></i> 乘车点
                    </div>
                    <div class="input">
                      <el-select v-model="put.start_id" placeholder="请选择" @change="start_change" class="paekr">
                        <el-option v-for="item in start_wz" :key="item.value" :label="item.text" :value="item.value">

                        </el-option>
                      </el-select>
                    </div>
                  </div>

                  <div class="row" v-if="0">
                    <div class="lab">

                    </div>
                    <div class="input">
                      <i class="el-icon-refresh"></i> バス停を入れ替える
                    </div>
                  </div>

                  <div class="row" v-if="source == 'highwaybus'">
                    <div class="lab">
                      <i class="el-icon-location"></i> 下车点
                    </div>
                    <div class="input">


                      <el-select v-model="put.end_id" placeholder="请选择" @change="end_change" class="paekr">
                        <el-option v-for="item in end_wz" :key="item.value" :label="item.text" :value="item.value">

                        </el-option>
                      </el-select>

                    </div>
                  </div>

                  <div class="row" v-if="source == 'highwaybus'">
                    <div class="lab">
                      <i class="el-icon-date"></i> 乗車日
                    </div>
                    <div class="input" @click="calendar_show = true">

                      <el-select v-model="put.date" placeholder="请选择" class="paekr">
                        <el-option v-for="item in dates" :key="item.value" :label="item.text" :value="item.value">

                        </el-option>
                      </el-select>


                    </div>
                  </div>
                  <div class="row" v-if="source == 'jbus'">
                    <div class="lab">
                      <i class="el-icon-date"></i> 乗車日
                    </div>
                    <div class="input">
                      <el-date-picker class="ipt" v-model="map.date" value-format="yyyy-MM-dd" align="right" type="date"
                        :placeholder="this.$lang('37405')" :picker-options="pickerOptions"> </el-date-picker>

                    </div>
                  </div>


                  <div class="line">

                  </div>

                  <div class="row" v-if="source == 'highwaybus'">
                    <div class="lab">
                      <i class="el-icon-user"></i> 人数
                    </div>
                    <div class="input">
                      <div class="row2">
                        <div class="lab">
                          <i class="el-icon-male"></i> 大人
                        </div>
                        <div class="input">
                          <div class="row2">
                            <div class="row2">
                              男 <el-input-number size="mini" v-model="put.old_man" />
                            </div>
                            <div class="row2">
                              女 <el-input-number size="mini" v-model="put.old_woman" />
                            </div>
                          </div>


                        </div>
                      </div>
                      <div class="row2">
                        <div class="lab">
                          <i class="el-icon-user-solid"></i> 儿童
                        </div>
                        <div class="input">
                          <div class="row2">
                            <div class="row2">
                              男 <el-input-number size="mini" v-model="put.child_man" />
                            </div>
                            <div class="row2">
                              女 <el-input-number size="mini" v-model="put.child_woman" />
                            </div>
                          </div>


                        </div>
                      </div>
                    </div>
                  </div>


                  <div class="do_sreach" @click="get_res">
                    <i class="el-icon-search"></i> 搜索
                  </div>

                </div>



              </div>


            </div>
          </div>
        </div>
      </div>
      <div class="buss">

    	<div  v-show="source == 'highwaybus' && is_res_show == false">
				<img class="fir" v-if="current == 0" src="https://japanbus.cn/ddmap.png" mode="widthFix"  ></img>
				<img class="fir" v-if="current == 3"  src="https://japanbus.cn/gaoshan.jpg" mode="widthFix"  ></img>
			</div>
        <div class="row" v-for="(vo, i) in res">

          <div class="staterandtime">
            <div class="top" v-if="source == 'highwaybus'">
              <div class="start">


                <div class="ggz">
                  
                  <span>{{ tt(vo.start_tit) }}</span>
                </div>

                <div class="">
                  {{ vo.start_date }}
                </div>
                <div class="">
                  {{ vo.start_time }}
                </div>

              </div>
              <div class="mmd">
                <img src="~@/../static/v3/rjt.png" mode="widthFix" />

              </div>

              <div class="end">



                <div class="ggz">
                 
                  <span>{{ tt(vo.end_tit) }}</span>
                </div>

                <div class="">
                  {{ vo.end_date }}
                </div>

                <div class="">
                  {{ vo.end_time }}
                </div>

              </div>
            </div>
          </div>

          <div class="line"></div>
          <div class="bott">
            <div class="info">
              <div class="linetit">
                路线: {{ tt(vo.line) }}
              </div>
              <div class="">
                编号: <span class="sntit">{{ tt(vo.sn) }}</span>
              </div>
            </div>

            <div class="icons">
              <div class="icon" v-for="src in vo.icon">
                <img :src="src" />
              </div>
            </div>

          </div>


          <div class="line"></div>



          <div class="t3" v-if="source == 'jbus'">
            <div class="xt1  " v-for="(pt, n) in vo.starts" :key="n">
              <div class="">
                {{ pt.tit }}
              </div>
              <div class="">
                {{ pt.time }}
              </div>
            </div>

            <div class="xt1 xt2" v-for="(pt, n) in vo.ends" :key="n">

              <div class="">
                {{ pt.tit }}
              </div>
              <div class="">
                {{ pt.time }}
              </div>
            </div>

          </div>
          <div class="line"></div>
          <div class="buybtn">
            <div class="price">
              {{ $lang(48468) }} {{ to_price(vo.price) }}
            </div>
            <div class="btnx" @click="buy(vo)">
              <div class="btn">
                购买
              </div>
            </div>
          </div>

        </div>
      </div>


    </div>

  </div>
</template>
<script>
import nav_list from '../index/nav_list.vue';
import langMixin from "../../utils/lang.js";
export default {
  name: "bus_list",
  mixins: [langMixin],
  components: {
    nav_list
  },


  data() {
    return {
      pickerOptions: {
        disabledDate(time) {
          if (time.getTime() < new Date(new Date().toLocaleDateString()).getTime()) {
            return true
          }
          if (time.getTime() > (Date.now() + 1000 * 60 * 60 * 24 * 89)) {
            return true
          }
          return false
        },


      },
      fullscreenLoading: false,
      calendar_show: false,
      tabList: [],
      start_date: '',
      end_date: '',
      conf: [],
      curr: 0,
      current:0,
      a: 'bus_list',
      list: [],
      source: 'highwaybus',
      source: 'jbus',
      source_id: 0,
      hot_id: 0,
      dpcd: 0,
      apcd: 0,
      source_inc: 1.5,
      start_wz: [{ value: 0, text: '请选择' }],
      end_wz: [{ value: 0, text: '请选择' }],
      dates: [],
      put: {
        old_man: 0,
        old_woman: 0,
        child_man: 0,
        child_woman: 0,
        start_id: 0,
        end_id: 0,
        date: '',
      },
      res: [],
      map: {
        date: '2024-12-27',
      },
      rate: 0,// 汇率
      is_res_show : false,

    };
  },
  mounted() {
    // this.get_start()
    // this.h_get_res()
    // this.j_get_res()
    this.current = this.$route.query.curr
    this.f5()
  },


  methods: {
    lang_after(){
				if (this.source == 'highwaybus') {
					 
					let start_wz = [...this.start_wz]
					this.start_wz  = []
				 
					for (let vo of start_wz) {
						vo.text= this.tt(vo.text)
					}
					this.start_wz = start_wz

					let end_wz = [...this.end_wz]
					this.end_wz  = []
					for (let vo of end_wz) {
						vo.text= this.tt(vo.text)
					}
					this.end_wz = end_wz
					  
				}
				
			},
    cdd(e) {
      this.put.date = e[0]
      this.calendar_show = false
    },
    get_res() {

      if (this.source == 'highwaybus') {
        this.h_get_res()
      } else {
        this.j_get_res()
      }
    },
    to_price(v) {
      if (this.cache('lang_config') == 'jp') {
        return v;
      }
      return (parseFloat(v) / this.rate).toFixed(2)
    },
    f5() {
      this.get("/hot/index").then((e) => {
        this.rate = e.rate
        this.map = e.map
        this.conf = e.list
        let lst = []
        for (let vo of e.list) {
          if (this.cache('lang_config') == 'cn') {

            lst.push({
              name: vo.title
            })
          } else {
            lst.push({
              name: vo.jp_tit
            })
          }
        }
        this.tabList = lst
        this.onChange(this.current)


      });
    },

    bindDateChange(e) {
      this.map.date = e.detail.value
    },
    onChange(e) {
      this.is_res_show = false
      this.current = e
      this.source = this.conf[e].source
      this.source_id = this.conf[e].source_id
      this.hot_id = this.conf[e].id
      this.dpcd = this.conf[e].dpcd
      this.apcd = this.conf[e].apcd
      this.source_inc = parseFloat( this.conf[e].inc_rate)
      this.res = []
      this.get_start()
      if (this.source == 'jbus') {
					this.get_res()
				} else {
					this.put.start_id = this.conf[e].def_start_id
					this.put.end_id = this.conf[e].def_end_id
					this.h_get_start('end')
          let ths = this
      setTimeout(() => {
        ths.h_get_date()
      }, 1000)
				}
    },
    buy(vo) {
      vo.date = this.map.date
      this.cache('hot_vo', vo)
      this.cache('hot_source', this.source)
      this.cache('hot_source_id', this.source_id)
      this.cache('hot_id', this.hot_id)
      this.jump("/hot/pre_order")
    },
    get_start() {
      if (this.source == 'highwaybus') {
        this.h_get_start()
      }
    },
    start_city_show() {
      this.$refs.start_city.show()
    },
    end_city_show() {
      this.$refs.end_city.show()
    },
    start_change(e) {

      this.h_get_start('end')
      let ths = this
      setTimeout(() => {
        ths.h_get_date()
      }, 1000)

    },
    end_change(e) { },
    h_get_date() {
      // https://www.highwaybus.com/gp/ajaxPulldown?mode=date&id=468&onStation=1143&offStation=
      let url = `https://serverapi.173key.cn/hb/gp/ajaxPulldown?mode=date&id=${this.source_id}&onStation=${this.put.start_id}&offStation=`

      this.$axios.request({
        url: url,
        timeout: 1000,
      }).then((res) => {
        // 创建一个DOMParser实例
        var parser = new DOMParser();

        // 使用parseFromString方法解析XML字符串
        var xmlDoc = parser.parseFromString(res.data, "text/xml");

        // 现在你可以像操作DOM一样操作这个xmlDoc对象了
        var rosen = xmlDoc.getElementsByTagName("rosen")
        let wz = []
        for (let i = 1; i < rosen[0].children.length; i += 4) {
          let id = rosen[0].children[i].innerHTML // 输出: 21
          // let txt = rosen[0].children[i+1].innerHTML // 输出: 21
          wz.push({
            value: id,
            text: id
          })
        }
        this.dates = wz
        this.put.date = wz[0].value
      }).catch((error) => {
        let ths = this
        setTimeout(() => {
          ths.h_get_date()
        }, 1000);
        console.error('请求出错:', error);
      });
    },
    h_get_start(t = 'start') {

      let url = 'https://serverapi.173key.cn/hb/gp/ajaxPulldown?mode=station_geton&id=' + this.source_id;

      if (t == 'end') {
        url = `https://serverapi.173key.cn/hb/gp/ajaxPulldown?mode=station_getoff&id=${this.source_id}&stationcd=${this.put.start_id}`
      }
      let ths = this
      this.$axios.request({
        url: url,
        timeout: 1000,
      }).then((res) => {

        // 创建一个DOMParser实例
        var parser = new DOMParser();

        // 使用parseFromString方法解析XML字符串
        var xmlDoc = parser.parseFromString(res.data, "text/xml");

        // 现在你可以像操作DOM一样操作这个xmlDoc对象了
        var rosen = xmlDoc.getElementsByTagName("rosen")
        let wz = [{ value: 0, text: '请选择' }]
        for (let i = 1; i < rosen[0].children.length; i += 4) {
          let id = rosen[0].children[i].innerHTML // 输出: 21
          let txt = rosen[0].children[i + 1].innerHTML // 输出: 21
          this.push_hot_jp(txt)
          wz.push({
            value: id,
            text: txt
          })
        }

        if (t == 'start') {
          this.start_wz = wz
        }

        if (t == 'end') {
          this.end_wz = wz
          console.log('this.end_wz,', this.end_wz)
        }
        this.get_cn()
      }).catch((error) => {
        ;
        setTimeout(() => {
          ths.h_get_start(t)
        }, 1000);
        console.error('请求出错:', error);
      });
    },
    h_get_res() {
      if (this.put.start_id == 0) {
        return this.$message('请选择乘车地点')
      }
      if (this.put.end_id == 0) {
        return this.$message('请选择下车地点')
      }
      if (this.put.date == '') {
        return this.$message('请选择乘车日期')
      }
      if (this.put.old_man + this.put.old_woman + this.put.child_man + this.put.child_woman <= 0) {
        return this.$message('请选择乘客数量')
      }
      this.is_res_show = true
      this.res = []
      this.fullscreenLoading = true
      let dt = this.put.date.replaceAll('-', '')
      let url = `https://serverapi.173key.cn/hb/gp/reservation/rsvPlanList?mode=search&route=1&lineId=${this.source_id}&nearCheckOnStation=&nearCheckOffStation=&onStationCd=${this.put.start_id}&offStationCd=${this.put.end_id}&bordingDate=${dt}&danseiNum=${this.put.old_man + this.put.child_man}&zyoseiNum=${this.put.old_woman + this.put.child_woman}&adultMen=${this.put.old_man}&adultWomen=${this.old_woman}&childMen=${this.put.child_man}&childWomen=${this.put.child_woman}&handicapAdultMen=0&handicapAdultWomen=0&handicapChildMen=0&handicapChildWomen=0#infomationArea`
      this.$axios.request({
        url: url
      }).then((res) => {
        this.fullscreenLoading = false
         
						const parser = new DOMParser();
						  const doc = parser.parseFromString(res.data, "text/html");
						let lst =	doc.getElementsByClassName('busSvclistItem')
				        console.log('lst', lst)
						for (let i =0; i< lst.length;i++) {
							let vo = lst[i]
							let row = {}
							
							let prices = vo.getElementsByClassName('busSvclistItem_howToBuy')[0].getElementsByTagName('ul')
							let price = 0
							let form_str = ''
							for (let j = 0; j < prices.length; j++) {
								let vp = prices[j]
								let p = vp.getElementsByClassName('price')[0].innerHTML
								let form = vp.getElementsByTagName('form')
								p = parseInt(p.replaceAll(',', '').replaceAll('円', ''))
								if (form.length > 0 && price < p) {
									price = p
									form_str = form[0].outerHTML
								}
								
							}
							if (price <= 0) {
								continue
							}
							row.org_price = price 
							row.price = price *this.source_inc
						 
							
							
							// 出发地点
							
							let start = vo.getElementsByClassName('dep')[0].getElementsByTagName('p')
							
							row.start_tit = start[0].innerHTML
							row.start_date = start[1].innerHTML.replaceAll('<span>', '').replaceAll('</span>', '')
							row.start_time = start[2].innerHTML.replaceAll('発', '')
							row.start_time = row.start_time.replaceAll('発', '')
							
							let end = vo.getElementsByClassName('arr')[0].getElementsByTagName('p')
							row.end_tit = end[0].innerHTML
							row.end_date = end[1].innerHTML.replaceAll('<span>', '').replaceAll('</span>', '')
							row.end_time = end[2].innerHTML.replaceAll('着', '')
							row.end_time = row.end_time.replaceAll('着', '')
							
							let line = vo.getElementsByClassName('line-num')[0].getElementsByTagName('p')
							row.line = line[0].innerHTML.replaceAll('<span>路　線：</span>', '')
							row.line = this.clearss(row.line)
							row.sn = line[1].innerHTML.replaceAll('<span>便番号：</span>', '').replaceAll('&nbsp;',' ')
							row.sn = this.clearss(row.sn)
							 
							
							
							let icons = vo.getElementsByClassName('facility')[0].getElementsByTagName('img')
							let imgs = []
							for (let n = 0; n < icons.length; n++) {
								let src = icons[n].getAttribute('src')
                if (src.indexOf('toilet_color') !== -1) {
									continue
								}
								src = 'https://serverapi.173key.cn/hb' + src
								imgs.push(src)
							}
							
							row.icon = imgs
							this.push_hot_highwaybus_jp(row)
							this.res.push(row)
							
						}
						this.get_cn()
        
      }).catch((error) => {
        
        console.error('请求出错:', error);
      });
    },

    j_get_res() {
      this.res = []
      this.fullscreenLoading = true
      const timestamp = new Date().getTime();
      let d = this.map.date.split('-')
      let ym = d[0] + '' + d[1]
      let dy = d[2]

      let url = `https://yichen.geslan.cn/jbus/hon/Route/ListDate?random=${timestamp}&dpcd=${this.dpcd}&apcd=${this.apcd}&dtym=${ym}&dtdd=${dy}&gpcd=&rocd=&bncd=&around=0&updn=&uncd=&bscd=`
      this.$axios.request({
        url: url,
        timeout: 200000
      }).then((res) => {
        this.fullscreenLoading = false
         
        
						const parser = new DOMParser();
					  	const doc = parser.parseFromString(res.data, "text/html");
						let lst =	doc.getElementsByClassName('in-section')
			 
						for (let i =0; i< lst.length;i++) {
							let row = {}
							let vo =lst[i]
							let info1 = vo.getElementsByClassName('route-title')[0]
							
							row.line = info1.getElementsByTagName('h2')[0].innerHTML
							row.sn = info1.getElementsByTagName('p')[0].innerHTML
							row.sn = row.sn.replaceAll('&nbsp;', ' ')
							let icons = vo.getElementsByClassName('facility-item')
							let imgs = []
							for (let n = 0; n < icons.length; n++) {
								let src = icons[n].getAttribute('src')
								src = 'https://secure.j-bus.co.jp' + src
								imgs.push(src)
							}
							row.icon = imgs
							
							// body-group-reserve
							let prices =  vo.getElementsByClassName('body-group-reserve')
								
							let price = 0
							let form_str = ''
							let seat = 0
							let dscd = 0
							let discount_student = 0
							let discount_disabilities = 0
							let rimid = 0
							for (let j = 0; j < prices.length; j++) {
								let vp = prices[j]
								let stock = parseInt(vp.getAttribute('data-seat'))
								if (!stock) {
									 
									continue
								} else {
									 
								}
								let p = vp.getElementsByTagName('strong')[0].innerHTML
									
								
									
								// console.log('ppp', p)
								p = p.replaceAll(',', '').replaceAll('円', '').replaceAll(' ', '')
								// console.log('ppp', p)
								if (p.indexOf('～') > -1) {
									p = p.split('～')[1]
								}
								// console.log('ppp', p, stock)
								p = parseInt(p)
								if (stock > 5 && price < p) {
									price = p
									seat = stock
									dscd = vp.getAttribute('data-dscd')
									discount_student = vp.getAttribute('data-discount-student')
									rimid = vp.getAttribute('data-rimid')
									discount_disabilities = vp.getAttribute('data-discount-disabilities')
										
								}
								
							}
							if (price <= 0) {
								continue
							}
							
							row.org_price = price
							row.price = price *this.source_inc
							row.seat = seat
							row.dscd = dscd
							row.discount_student = discount_student
							row.rimid = rimid
							row.discount_disabilities = discount_disabilities
							// is-departure
							
							row.starts = []
							let stars = vo.getElementsByClassName('is-departure')
							for (let j = 0; j < stars.length; j++) {
								let vp = stars[j]
								let time = vp.getElementsByClassName('js-stop-time')[0].innerHTML
								let code = vp.getAttribute('data-stopcode')
								let tit = vp.getElementsByTagName('a')[0].innerHTML
								time = time.replaceAll('\\n', '').replaceAll(' ', '')
								time = this.clearss(time)
								tit = this.clearss(tit)
								row.starts.push({
									tit:tit,
									title:tit,
									time:time,
									id:code,
								})
							} 
							row.ends = []
							let ends = vo.getElementsByClassName('is-arrival')
							for (let j = 0; j < ends.length; j++) {
								let vp = ends[j]
								let time = vp.getElementsByClassName('js-stop-time')[0].innerHTML
								let code = vp.getAttribute('data-stopcode')
								
								let tit = vp.getElementsByTagName('a')[0].innerHTML
								time = this.clearss(time)
								tit = this.clearss(tit)
								row.ends.push({
									tit:tit,
									title:tit,
									time:time,
									id:code,
								})
							}
							
							let data = vo.getElementsByClassName('routeinfo')[0]
							row.gpcd = data.getAttribute('data-gpcd')
							row.rocd = data.getAttribute('data-rocd')
							row.bncd = data.getAttribute('data-bncd')
							row.bscd = data.getAttribute('data-bscd')
							row.sthz = data.getAttribute('data-sthz')
							row.ymd = data.getAttribute('data-ymd')
							row.uncd = data.getAttribute('data-uncd')
							row.seatmap = data.getAttribute('data-seatmap')
							row.unkyuflg = data.getAttribute('data-unkyuflg')
							row.vacantdiv = data.getAttribute('data-vacantdiv')
						 
							row.sn = this.clearss(row.sn)
							row.line = this.clearss(row.line)
							this.res.push(row)
							

							
						}
						for (let i = 0; i<= this.res.length-1; i++) {
							this.push_hot_jbus(this.res[i])
						}
						
						this.get_cn()
      }).catch((error) => {

        console.error('请求出错:', error);
      });
    },
  }
}
</script>

<style scoped lang="scss">
.gb-tabs {
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  border-radius: 8px;
  background: #fff;
  overflow: hidden;
}

.gb-tabs-body {
  background: transparent !important;
  padding: 20px;
}
 
.tbatba {
  background-color: #fff;
  padding: 0;
  width: 96%;
  margin: auto;
  margin-top: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
}

.root_inner {
  background-color: #fff;
  padding: 0;
  width: 96%;
  margin: auto;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
}

.sreach {
  margin: 20px auto;
  border-radius: 12px;
  padding: 20px;
  font-size: 14px;
  text-align: center;
  background: #fff;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);

  .row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 0;
    border-bottom: 1px solid rgba(0, 0, 0, 0.04);

    &:last-child {
      border-bottom: none;
    }

    .paekr {
      background-color: #fff;
      width: 100%;
      
      :deep(.el-input__inner) {
        border-radius: 8px;
        border: 1px solid rgba(0, 0, 0, 0.1);
        padding: 8px 12px;
        transition: all 0.3s ease;

        &:hover, &:focus {
          border-color: #3956DA;
          box-shadow: 0 0 0 2px rgba(57, 86, 218, 0.1);
        }
      }
    }

    .lab {
      flex: 0 0 20%;
      color: #2c3e50;
      font-weight: 500;
    }

    .input {
      flex: 0 0 75%;
      text-align: left;
    }
  }

  .row2 {
    display: flex;
    font-size: 13px;
    flex: 0 0 47%;
    justify-content: space-between;
    align-items: center;
    white-space: nowrap;
    padding: 8px 0;

    .lab {
      flex: 0 0 10%;
      color: #4a5568;
    }

    .input {
      flex: 0 0 90%;
      text-align: left;
    }
  }

  .do_sreach {
    margin: 30px auto;
    width: 80%;
    height: 44px;
    line-height: 44px;
    border-radius: 22px;
    background: linear-gradient(135deg, #3956DA, #4a6ee0);
    color: #fff;
    font-size: 15px;
    font-weight: 500;
    text-align: center;
    box-shadow: 0 4px 12px rgba(57, 86, 218, 0.3);
    transition: all 0.3s ease;
    cursor: pointer;

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 6px 16px rgba(57, 86, 218, 0.4);
    }

    &:active {
      transform: translateY(0);
      box-shadow: 0 2px 8px rgba(57, 86, 218, 0.3);
    }
  }
}

.line {
  margin: 8px 0;
  height: 1px;
  border-bottom: 1px dashed rgba(232, 91, 68, 0.3);
}

.buss {
  flex: 0 0 60%;
  padding: 0 15px;

  .iiimzz {
    min-width: 20px;
    width: 20px;
    opacity: 0.8;
  }

  .empty {
    width: 95%;
    margin: 0 auto;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
    border-radius: 12px;
    padding: 120px 0;
    background: #fff;
  }

  img {
    width: 100%;
  }

  .row {
    padding: 20px;
    width: 98%;
    margin: 12px auto;
    border-radius: 16px;
    background: linear-gradient(135deg, #fff 0%, #fafbfc 100%);
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06);
    border: 1px solid rgba(0, 0, 0, 0.04);
    transition: all 0.3s ease;
    position: relative;
    overflow: hidden;

    // 添加装饰性渐变边框
    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      height: 3px;
      background: linear-gradient(90deg, #3956DA, #50A2F8, #2063FF);
      opacity: 0;
      transition: opacity 0.3s ease;
    }

    &:hover {
      transform: translateY(-4px);
      box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
      border-color: rgba(57, 86, 218, 0.1);

      &::before {
        opacity: 1;
      }
    }

    .date {
      font-size: 16px;
      padding-bottom: 4px;
      color: #2c3e50;
      font-weight: 500;
    }

    .t3 {
      display: flex;
      border-radius: 12px;
      flex-direction: row;
      flex-wrap: wrap;
      padding: 18px;
      gap: 10px;
      background: rgba(248, 249, 250, 0.8);
      border: 1px solid rgba(0, 0, 0, 0.05);
      margin: 16px 0;

      .xt1 {
        padding: 12px 18px;
        box-sizing: border-box;
        background: linear-gradient(135deg, #E8F3FF 0%, #d5e9ff 100%);
        border-radius: 10px;
        color: #175EFF;
        font-size: 14px;
        text-align: center;
        font-weight: 600;
        transition: all 0.3s ease;
        border: 1px solid rgba(23, 94, 255, 0.1);
        box-shadow: 0 2px 8px rgba(23, 94, 255, 0.1);
        position: relative;
        overflow: hidden;
 

        // 添加光泽效果
        &::after {
          content: '';
          position: absolute;
          top: 0;
          left: -100%;
          width: 100%;
          height: 100%;
          background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
          transition: left 0.5s ease;
        }

        &:hover {
          background: linear-gradient(135deg, #d5e9ff 0%, #c1e0ff 100%);
          transform: translateY(-2px);
          box-shadow: 0 4px 15px rgba(23, 94, 255, 0.2);

          &::after {
            left: 100%;
          }
        }
      }

      .xt2 {
        background: linear-gradient(135deg, #FFF7E9 0%, #fff0e0 100%);
        color: #FE7D00;
        border: 1px solid rgba(254, 125, 0, 0.1);
        box-shadow: 0 2px 8px rgba(254, 125, 0, 0.1);
 
        &:hover {
          background: linear-gradient(135deg, #fff0e0 0%, #ffe6d1 100%);
          box-shadow: 0 4px 15px rgba(254, 125, 0, 0.2);
        }
      }
    }

    .top {
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 14px;
      padding: 18px;
      background: linear-gradient(135deg, rgba(57, 86, 218, 0.05) 0%, rgba(80, 162, 248, 0.03) 100%);
      border-radius: 12px;
      margin-bottom: 16px;
      position: relative;

      // 添加装饰性图标背景
      &::after {
        content: '';
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 60px;
        height: 60px;
        background: radial-gradient(circle, rgba(57, 86, 218, 0.08) 0%, transparent 70%);
        border-radius: 50%;
        z-index: 0;
      }

      div {
        margin: 3px 0;
        position: relative;
        z-index: 1;
      }

      .start {
        flex: 0 0 38%;

        .ggz {
          font-weight: 600;
          color: #2c3e50;
          font-size: 16px;
          margin-bottom: 8px;

          span {
            background: linear-gradient(135deg, #3956DA, #50A2F8);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            background-clip: text;
          }
        }

        div:not(.ggz) {
          color: #6c757d;
          font-size: 13px;
          font-weight: 500;
        }
      }

      .end {
        text-align: right;
        flex: 0 0 38%;

        .ggz {
          font-weight: 600;
          color: #2c3e50;
          font-size: 16px;
          margin-bottom: 8px;

          span {
            background: linear-gradient(135deg, #FE7D00, #e85b44);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            background-clip: text;
          }
        }

        div:not(.ggz) {
          color: #6c757d;
          font-size: 13px;
          font-weight: 500;
        }
      }

      .mmd {
        flex: 0 0 24%;
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        z-index: 2;

        img {
          width: 80%;
          filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.1));
          transition: transform 0.3s ease;
        }
      }
    }

    .row:hover .top .mmd img {
      transform: scale(1.1);
    }

    .bott {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      padding: 16px 18px;
      background: rgba(248, 249, 250, 0.6);
      border-radius: 10px;
      margin: 12px 0;

      .info {
        flex: 0 0 65%;

        .linetit {
          color: #e85b44;
          margin: 0 0 8px 0;
          font-weight: 600;
          font-size: 15px;
          display: flex;
          align-items: center;

          &::before {
            content: '🚌';
            margin-right: 8px;
            font-size: 16px;
          }
        }

        .sntit {
          color: #495057;
          font-weight: 500;
          background: rgba(57, 86, 218, 0.1);
          padding: 4px 8px;
          border-radius: 6px;
          display: inline-block;
          font-size: 13px;
        }

        // 添加编号标签样式
        div:not(.linetit) {
          display: flex;
          align-items: center;
          margin-top: 8px;
          font-size: 14px;
          color: #6c757d;

          &::before {
            content: '📋';
            margin-right: 6px;
            font-size: 14px;
          }
        }
      }

      .icons {
        flex: 0 0 32%;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        gap: 6px;
        flex-wrap: wrap;

        .icon {
          width: 28px;
          height: 28px;
          background: #fff;
          border-radius: 6px;
          padding: 4px;
          box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
          transition: all 0.3s ease;
          display: flex;
          align-items: center;
          justify-content: center;

          img {
            width: 100%;
            height: 100%;
            object-fit: contain;
          }

          &:hover {
            transform: translateY(-2px);
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
            background: #f8f9fa;
          }
        }
      }
    }

    .buybtn {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 18px;
      background: linear-gradient(135deg, rgba(232, 91, 68, 0.05) 0%, rgba(254, 125, 0, 0.03) 100%);
      border-radius: 12px;
      margin-top: 16px;
      border: 1px solid rgba(232, 91, 68, 0.1);

      .price {
        flex: 0 0 55%;
        color: #e85b44;
        font-weight: 700;
        font-size: 22px;
        display: flex;
        align-items: center;

       

        // 添加价格动画效果
        span {
          background: linear-gradient(135deg, #e85b44, #FE7D00);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
        }
      }

      .btnx {
        flex: 0 0 42%;
        display: flex;
        justify-content: flex-end;

        .btn {
          width: 130px;
          padding: 12px 0;
          border-radius: 25px;
          background: linear-gradient(135deg, #e85b44 0%, #FE7D00 100%);
          color: #fff;
          font-size: 15px;
          font-weight: 600;
          text-align: center;
          border: none;
          transition: all 0.3s ease;
          cursor: pointer;
          box-shadow: 0 4px 15px rgba(232, 91, 68, 0.3);
          position: relative;
          overflow: hidden;

          // 添加光泽效果
          &::before {
            content: '';
            position: absolute;
            top: 0;
            left: -100%;
            width: 100%;
            height: 100%;
            background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
            transition: left 0.5s ease;
          }

          &:hover {
            transform: translateY(-3px);
            box-shadow: 0 8px 25px rgba(232, 91, 68, 0.4);

            &::before {
              left: 100%;
            }
          }

          &:active {
            transform: translateY(-1px);
            box-shadow: 0 4px 15px rgba(232, 91, 68, 0.3);
          }
        }
      }
    }
  }
}

.wiwiw {
  display: flex;
  width: 92%;
  margin: 0px auto;
  border-top: 1px solid rgba(0, 0, 0, 0.08);
  padding: 40px 0;
  gap: 20px;

  .lefefe {
    flex: 0 0 33%;
    padding-right: 15px;
  }

  // 响应式设计
  @media (max-width: 1200px) {
    width: 95%;
    flex-direction: column;

    .lefefe {
      flex: none;
      padding-right: 0;
      margin-bottom: 20px;
    }

    .buss {
      flex: none;
      padding: 0 10px;
    }
  }

  @media (max-width: 768px) {
    width: 98%;
    padding: 20px 0;

    .buss .row {
      width: 100%;
      padding: 15px;
      margin: 10px auto;

      .top {
        flex-direction: column;
        text-align: center;

        .start, .end {
          flex: none;
          margin: 10px 0;
        }

        .mmd {
          flex: none;
          margin: 15px 0;
        }
      }

      .bott {
        flex-direction: column;

        .info {
          flex: none;
          margin-bottom: 15px;
        }

        .icons {
          flex: none;
          justify-content: center;
        }
      }

      .buybtn {
        flex-direction: column;
        text-align: center;

        .price {
          flex: none;
          margin-bottom: 15px;
          justify-content: center;
        }

        .btnx {
          flex: none;
          justify-content: center;
        }
      }
    }
  }
}

.fir {
  margin-top: 2vh;
  // padding: 10px;
  // background-color: #fff;
  // border: 1px solid #4196eb;
  border-radius: 10px;
  box-shadow: 4px 4px 4px #eee;
}
 
</style>



// WEBPACK FOOTER //
// src/pages/hot/index.vue